import React, { useContext } from "react"
// PDF;
import * as AppConstants from "../../../../utility/AppConstants"
import save from "save-file"

import axios from "axios"
import { generaSVGGrafico } from "../../../../utility/Utility"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"

interface TabTitleProps {
    title: string
    anno: string
    codIsa?: string
    macroarea?: string
}

function TabTitle(props: TabTitleProps) {
    let title = props.title
    const [multiAnnoState, _] = useContext(MultiAnnoContext)

    return (
        <div className="row">
            <div className="col-auto">
                <h1 className="h3"> {title} </h1>
            </div>

            <div className="col">&nbsp;</div>

            <div className="col-auto">
                <a
                    rel="noopener noreferrer"
                    title={"Download EXCEL " + title}
                    href="downloadExcel"
                    onClick={(e) =>
                        multiAnnoState.isMultiAnno
                            ? downloadExcelDatiNazionaliMA(props, e, () => {})
                            : downloadExcel(props, e)
                    }
                >
                    <i className="fas fas fa-file-excel fa-2x mr-2"></i>
                </a>

                <a
                    rel="noopener noreferrer"
                    title={"Download PDF " + title}
                    href="downloadPdf"
                    onClick={(e) =>
                        multiAnnoState.isMultiAnno
                            ? downloadPDFDatiNazionaliMA(props, e, () => {})
                            : downloadPDF(props, e)
                    }
                >
                    <i className="fas fas fa-file-pdf fa-2x mr-2"></i>
                </a>
            </div>
        </div>
    )
}

function appendBlob(
    formData: FormData,
    element: HTMLCanvasElement | null,
    index: number
) {
    //ctx?.forEach((e:any) => e?.draw())
    return new Promise<void>((resolve, reject) => {
        element?.toBlob(async (blob) => {
            if (blob != null) {
                formData.append("fileNazionali" + (index + 1).toString(), blob)
                console.log("append graph " + (index + 1))

                resolve()
            } else {
                resolve()
            }
        }, "image/jpeg")
    })
}
function downloadExcel(props: TabTitleProps, e: React.MouseEvent<any>) {
    console.log("prosp excel: ", props)
    e.preventDefault()
    let natGiuridica = null
    let title = props.title
    let codIsa = props.codIsa
    let macroarea = props.macroarea
    let nomeExcel = ""

    if (
        title.toUpperCase() === AppConstants.TITLE_PERSONE_FISICE.toUpperCase()
    ) {
        natGiuridica = "U"
        nomeExcel = `datiNazionali_${props.anno}_PersoneFisiche`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()
    ) {
        natGiuridica = "5"
        nomeExcel = `datiNazionali_${props.anno}_SocietaPersone`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_SOCIETA_CAPITALI.toUpperCase()
    ) {
        natGiuridica = "6"
        nomeExcel = `datiNazionali_${props.anno}_SocietaCapitali`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_ENTI_NON_COMMERCIALI.toUpperCase()
    ) {
        natGiuridica = "8"
        nomeExcel = `datiNazionali_${props.anno}_EntiNonCommerciali`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_TOTALI.toUpperCase()
    ) {
        natGiuridica = "0"
        nomeExcel = `datiNazionali_${props.anno}_Totali`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_MACROAREE_TERRITORIALI.toUpperCase()
    ) {
        natGiuridica = "T"
        nomeExcel = `datiNazionali_${props.anno}_Macroaree`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_SOC_CAPITALI_ENTI_NON_COMMERCIALI.toUpperCase()
    ) {
        natGiuridica = "M"
        nomeExcel = `datiNazionali_${props.anno}_SocietaCapitaliEntiNonCommerciali`
    }

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const formData = new FormData()
    formData.append("anno", props.anno)
    formData.append("natGiuridica", natGiuridica as string)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "filePie",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("pie_chart") as Node
            )
        )
    )
    formData.append(
        "fileBar",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("bar_chart") as Node
            )
        )
    )

    //console.log((new XMLSerializer).serializeToString(document.getElementById('bar_chart')));

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_NAZIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
            //test(excelByte, nomeExcel);
            //console.log(excelByte);
        })
        .catch((err) => {
            //$("#chiudi").click();
        })
}

function downloadPDF(props: TabTitleProps, e: React.MouseEvent<any>) {
    console.log("prosp pdf: ", props)
    e.preventDefault()
    let natGiuridica = null
    let title = props.title
    let codIsa = props.codIsa
    let macroarea = props.macroarea
    let nomePDF = ""

    if (
        title.toUpperCase() === AppConstants.TITLE_PERSONE_FISICE.toUpperCase()
    ) {
        natGiuridica = "U"
        nomePDF = `datiNazionali_${props.anno}_PersoneFisiche`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()
    ) {
        natGiuridica = "5"
        nomePDF = `datiNazionali_${props.anno}_SocietaPersone`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_SOCIETA_CAPITALI.toUpperCase()
    ) {
        natGiuridica = "6"
        nomePDF = `datiNazionali_${props.anno}_SocietaCapitali`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_ENTI_NON_COMMERCIALI.toUpperCase()
    ) {
        natGiuridica = "8"
        nomePDF = `datiNazionali_${props.anno}_EntiNonCommerciali`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_TOTALI.toUpperCase()
    ) {
        natGiuridica = "0"
        nomePDF = `datiNazionali_${props.anno}_Totali`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_MACROAREE_TERRITORIALI.toUpperCase()
    ) {
        natGiuridica = "T"
        nomePDF = `datiNazionali_${props.anno}_Macroaree`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_SOC_CAPITALI_ENTI_NON_COMMERCIALI.toUpperCase()
    ) {
        natGiuridica = "M"
        nomePDF = `datiNazionali_${props.anno}_SocietaCapitaliEntiNonCommerciali`
    }

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const formData = new FormData()
    formData.append("anno", props.anno)
    formData.append("natGiuridica", natGiuridica as string)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "filePie",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("pie_chart") as Node
            )
        )
    )
    formData.append(
        "fileBar",
        generaSVGGrafico(
            new XMLSerializer().serializeToString(
                document.getElementById("bar_chart") as Node
            )
        )
    )

    //console.log((new XMLSerializer).serializeToString(document.getElementById('bar_chart')));

    axios
        .post(AppConstants.URL_GET_PDF_DATI_NAZIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let pdfByte = response.data.pdf
            save(pdfByte, nomePDF)
            //$("#chiudi").click();
        })
        .catch((err) => {
            //$("#chiudi").click();
        })
}

async function downloadPDFDatiNazionaliMA(
    props: TabTitleProps,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,

    action: (f: boolean) => void
) {
    e.preventDefault()
    action(true)
    let nomePDF = `datiNazionali_${props.anno}_${Number(props.anno) + 2}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea
    let natGiuridica: string | null = null
    let title = props.title
    if (
        title.toUpperCase() === AppConstants.TITLE_PERSONE_FISICE.toUpperCase()
    ) {
        natGiuridica = "U"
        nomePDF = `datiNazionali_${props.anno}_${
            Number(props.anno) + 2
        }_PersoneFisiche`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()
    ) {
        natGiuridica = "5"
        nomePDF = `datiNazionali_${props.anno}_${
            Number(props.anno) + 2
        }_SocietaPersone`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_SOC_CAPITALI_ENTI_NON_COMMERCIALI.toUpperCase()
    ) {
        natGiuridica = "M"
        nomePDF = `datiNazionali_${props.anno}_${
            Number(props.anno) + 2
        }_SocietaCapitali_EntiNonCommerciali`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_TOTALI.toUpperCase()
    ) {
        natGiuridica = "0"
        nomePDF = `datiNazionali_${props.anno}_${Number(props.anno) + 2}_Totali`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_MACROAREE_TERRITORIALI.toUpperCase()
    ) {
        natGiuridica = "T"
        nomePDF = `datiNazionali_${props.anno}_${
            Number(props.anno) + 2
        }_Macroaree`
    }

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName(
        "NazionaliChart_ChartJs"
    ) as HTMLCollectionOf<HTMLCanvasElement>
    const formData = new FormData()
    formData.append("anno", props.anno)
    formData.append("natGiuridica", natGiuridica as string)

    let macroArea = macroarea == undefined || macroarea == "" ? "@@" : macroarea

    let codiceIsa = codIsa == undefined || codIsa == "" ? "@@" : codIsa

    formData.append("codIsa", codiceIsa)

    formData.append("macroarea", macroArea)

    for (let i = 0; i < regionChart.length; i++) {
        const element = regionChart.item(i)
        await appendBlob(formData, element, i)
    }

    console.log("done")

    axios
        .post(AppConstants.URL_GET_PDF_DATI_NAZIONALI_MA_V2, formData, {
            headers: config
        })
        .then((response) => {
            let pdfByte = response.data.pdf
            save(pdfByte, nomePDF)
        })
        .catch((err) => {})
        .finally(() => action(false))
}

async function downloadExcelDatiNazionaliMA(
    props: TabTitleProps,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,

    action: (f: boolean) => void
) {
    e.preventDefault()
    action(true)
    let natGiuridica: string | null = null
    let title = props.title
    let codIsa = props.codIsa
    let macroarea = props.macroarea
    let nomeExcel = ""

    if (
        title.toUpperCase() === AppConstants.TITLE_PERSONE_FISICE.toUpperCase()
    ) {
        natGiuridica = "U"
        nomeExcel = `datiNazionali_${props.anno}_PersoneFisiche`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()
    ) {
        natGiuridica = "5"
        nomeExcel = `datiNazionali_${props.anno}_SocietaPersone`
    }  else if (
        title.toUpperCase() ===
        AppConstants.TITLE_SOC_CAPITALI_ENTI_NON_COMMERCIALI.toUpperCase()
    ) {
        natGiuridica = "M"
        nomeExcel = `datiNazionali_${props.anno}__SocietaCapitali_EntiNonCommerciali`
    } else if (
        title.toUpperCase() === AppConstants.TITLE_TOTALI.toUpperCase()
    ) {
        natGiuridica = "0"
        nomeExcel = `datiNazionali_${props.anno}_Totali`
    } else if (
        title.toUpperCase() ===
        AppConstants.TITLE_MACROAREE_TERRITORIALI.toUpperCase()
    ) {
        natGiuridica = "T"
        nomeExcel = `datiNazionali_${props.anno}_Macroaree`
    }

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName(
        "NazionaliChart_ChartJs"
    ) as HTMLCollectionOf<HTMLCanvasElement>
    const formData = new FormData()
    formData.append("anno", props.anno)
    formData.append("natGiuridica", natGiuridica as string)

    let macroArea = macroarea == undefined || macroarea == "" ? "@@" : macroarea

    let codiceIsa = codIsa == undefined || codIsa == "" ? "@@" : codIsa

    formData.append("codIsa", codiceIsa)

    formData.append("macroarea", macroArea)

    for (let i = 0; i < regionChart.length; i++) {
        const element = regionChart.item(i)
        await appendBlob(formData, element, i)
    }

    console.log("done")

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_NAZIONALI_MA_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
        })

        .catch((err) => {})
        .finally(() => action(false))
}
export default TabTitle
